export function hasUnreadActivity(board: {
  dateLastActivity: Date | string | null;
  dateLastView: Date | string | null;
}): boolean;

export function hasUnreadActivity(board: {
  dateLastActivity?: Date | string | null;
  dateLastView?: Date | string | null;
}): boolean | undefined;

export function hasUnreadActivity(board: {
  dateLastActivity?: Date | string | null;
  dateLastView?: Date | string | null;
}): boolean | undefined {
  const { dateLastActivity, dateLastView } = board;
  if (dateLastActivity && dateLastView) {
    const _dateLastActivity =
      dateLastActivity instanceof Date
        ? dateLastActivity
        : new Date(dateLastActivity);
    const _dateLastView =
      dateLastView instanceof Date ? dateLastView : new Date(dateLastView);

    return _dateLastActivity > _dateLastView;
  } else {
    return undefined;
  }
}

export function checkIsTemplate({
  isTemplate,
  permissionLevel,
  premiumFeatures,
}: {
  isTemplate?: boolean;
  permissionLevel?: string;
  premiumFeatures?: string[];
}) {
  if (!isTemplate) {
    return false;
  } else if (
    permissionLevel === 'public' ||
    premiumFeatures?.includes('privateTemplates')
  ) {
    return true;
  }

  return false;
}
